import { EntityType, SearchFilter } from 'src/constants/enums';

export const SearchFields: Record<string, Array<string>> = {
  [EntityType.USER]: [SearchFilter.EMPLOYEE_ID],
  [EntityType.PROFILE]: [SearchFilter.PROFILE_ID],
  [EntityType.PROFILE_PERMISSIONS]: [SearchFilter.FIELD_ID],
  [EntityType.QUEUE]: [SearchFilter.QUEUE_NAME, SearchFilter.QUEUE_ID],
  [EntityType.USER_GROUPS]: [SearchFilter.USER_GROUP_ID],
  [EntityType.TRD_MAPPINGS]: [SearchFilter.DRIVER],
  [EntityType.TRD_TYPE]: [SearchFilter.TRD_TYPE],
  [EntityType.TRD_REASON_FOR_CONTACT]: [SearchFilter.TRD_REASON_FOR_CONTACT],
  [EntityType.TRD_DRIVER]: [SearchFilter.TRD_DRIVER],
  [EntityType.CASE_ENTITY]: [],
  [EntityType.LEGAL_REPORT]: [],
  [EntityType.DELETE_CASE_ENTITY]: []
};
